<script lang="ts" setup>
  import { defineComponent, onMounted, reactive } from "vue";
  import { useRoute } from 'vue-router';


  //servicos
  import * as service from "@/services/clienteService";

  //componentes

  import imgLogin from "@/assets/images/logoLogin.png";

  const route = useRoute();

  var controle = reactive({
    contratoId: 0,
    model: {} as service.Contrato,


    status: "",
    erro: "",
  })

  onMounted(async ()=>{
    pesquisar();
  })

  async function pesquisar() {

    console.log("busca contrato", controle.contratoId);
    if (route.params.contratoId) {
      controle.contratoId = parseInt(route.params.contratoId as string);
    }
  
    service.obterDados()
    .then(r=> {
      console.log(r);
      controle.model = r.contratos.find(c=> c.contratoId == controle.contratoId) as service.Contrato;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  } 

</script>

<template>

<div class="row mt-4">
        <div class="col-md-12 text-center">
            <img :src="imgLogin" alt="Logo" class="img-fluid img-logo mb-3" />
        </div>
    </div>

     <div class="row mt-4 mb-3">
        <div class="col-md-12">
            <h2>Contrato: {{ controle.model.plano?.nome }}</h2>
        </div>
    </div>

   <div class="row">
        <div class="col-md-12">
            <h4 v-if="controle.erro == ''">{{ controle.status }}</h4>
            <h4 v-if="controle.erro != ''" class="text-danger">{{ controle.erro }}</h4>
        </div>
    </div>

    

  <div class="mb-4 pb-4 bg-white" v-html="controle.model.texto"></div>

  <nav class="nnavbar fixed-bottom bg-body-tertiary">
    <form class="container-fluid justify-content-start">
      <RouterLink class="btn btn-primary btn-sm me-2" type="button" :to="{ name: 'PainelCliente' }">Voltar</RouterLink>
      <RouterLink class="btn btn-warning btn-sm " type="button" v-if="controle.model.dataAssinatura == null" :to="{ name: 'PainelClienteAssinarContrato', params: { contratoId: controle.contratoId } }">Assinar</RouterLink>
    </form>
  </nav>

</template>

<style lang="css" scoped>


</style>